import { observer } from "mobx-react";

import "./ReportsLimitNotice.scss";

/**
 * Подпись о том, что показаны не все отчеты проекта.
 *
 * Сервер отдает не больше последней тысячи отчетов на проект: один раздутый
 * проект без этого потолка вешал всю вкладку «Мои проекты». Полный список
 * по-прежнему доступен выгрузкой.
 *
 * @param {Object} props
 * @param {Object} props.project Проект с загруженными отчетами.
 */
const ReportsLimitNotice = observer(({ project }) => {
  const total = project.reportsTotal;
  const shown = project.reports?.length ?? 0;

  if (!total || total <= shown) return null;

  return (
    <p className="reports-limit-notice">
      Показаны последние {shown.toLocaleString()} отчётов из {total.toLocaleString()}.
      Полный список — в выгрузке отчётов.
    </p>
  );
});

export default ReportsLimitNotice;
